// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__2JQaa","footer":"ModalError_footer__2XWk8"};